import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AlertService } from '../../../providers/alert.service';
import { LotteryModel } from '../../../models/lottery.model';
import * as $ from 'jquery';
import { DrawTrend,clearCanvas } from './birck-trend.js';
import { PopoverController, NavParams } from 'ionic-angular';
import { LotteryOpenService } from '../../../services/lotteryopen.service';
import { BrickTrendScreen } from './brick-trend-screen/brick-trend-screen';
import { BettingOrderHelper } from '../../bettingorder/bettingorder.helper';


@Component({
    selector: 'brick-trend-page',
    templateUrl: 'brick-trend.html',
    providers: [LotteryOpenService, BettingOrderHelper]
})
export class BrickTrendPage implements OnChanges {

    /** 彩种数据 */
    @Input('brick') brick: LotteryModel;
    /** 选中位 */
    @Input('position') selected: string;
    /** 传入走势list数据 */
    @Input('list') openList: any[];
    /** 走势模式 */
    @Input() param: string;
    /** 彩种类型 */
    lotteryType: any;
    /** 保存开奖信息备用 */
    openListTemp: any[] = [];

    tabs: any[] = [];
    /** 出现次数 */
    appearCount = [];
    /** 最大连出 */
    maxContinueCount = [];
    /** 最大遗漏 */
    maxLoseCount = [];
    /** 平均遗漏 */
    averageLoseCount = [];
    /** 统计数组 */
    statisticArr = [];
    /** 奖号最小号码 */
    minNum: number = 0;
    /** 奖号最大号码 */
    maxNum: number = 0;
    /** 彩种开奖号码球数组 */
    openNumberArr = [];
    /** 走势图主体数组 */
    numMainList: TrendModel[] = [];
    /** 定位走势主体数组Temp */
    MainDataTemp = [];
    /** 号码走势主体Temp */
    numTrendMianData = [];
    /** 走势模型 */
    trendMode = '';
    /** 走势参数范围数组 */
    rangeArr = [
        { name: '最近30期', param: 'latest-30' },
        { name: '最近50期', param: 'latest-50' },
        { name: '今日数据', param: 'date-today' },
        { name: '昨日数据', param: 'date-yesterday' },
        { name: '前日数据', param: 'date-before-yesterday' },
    ];
    /** 走势图模式 */
    filterParamObj = [
        {
            title: '多号走势',
            mode: {
                '5x': '五星',
                '4q': '前四',
                '4h': '后四',
                '3q': '前三',
                '3z': '中三',
                '3h': '后三',
                '2q': '前二',
                '2h': '后二',
            }
        }, {
            title: '龙虎走势',
            mode: {
                '0102': '万千 | 万百',
                '0304': '万十 | 万个',
                '1213': '千百 | 千十',
                '1423': '千个 | 百十',
                '2434': '百个 | 十个',
            }
        }
    ];
    /** 是否需要调节Y轴高度  用于适配安卓内核  */
    adjustHeight = false;
    /** 仅奖号走势 */
    numberTrend = false;
    constructor(
        private alert: AlertService,
        private popCtrl: PopoverController,
        private lotteryService: LotteryOpenService,
        private navPar: NavParams,
        private bettinghelper: BettingOrderHelper,
    ) {
        this.param = 'dingwei';
        this.trendMode = 'dingwei';
        this.brick = this.navPar.data.brick || {};
        this.numberTrend = ['30012', '30013', '30014', '30015', '30016', '95000'].includes(this.brick.LotteryCode) ? true : false;
        this.lotteryType = this.brick.LotteryType;
        this.queryTrend();
        if(this.numberTrend) return;
        let timer = setInterval(() => {
            if ($('brick-trend-page') && $('.trend-content')) {
                if ($('.main-trend').offset().top > 288) {
                    this.adjustHeight = true;
                    $('.main-trend').attr('style', 'top:239px;' + 'width:' + $('.trend-content').width() + 'px');
                } else {
                    $('.main-trend').attr('style', 'width:' + $('.trend-content').width() + 'px');
                }
                clearInterval(timer);
            }
        }, 50)
    }
    getMarkSixColor(number) {
        let num = Number(number);
        return this.bettinghelper.getLetteryMarkSixColor(num).color;
    }
    ngOnChanges(changes: SimpleChanges): void {
        for (let change in changes) {
            if (changes[change]) {
                if (changes.brick) {
                    this.brick = changes.brick.currentValue;
                    this.lotteryType = this.brick.LotteryType;
                    this.param = this.lotteryType == '01' ? this.param : 'dingwei';
                    this.trendMode = this.lotteryType == '01' ? this.trendMode : 'dingwei';
                    this.initTabs(this.brick.LotteryType);
                }
                if (changes.selected) {
                    this.selected = changes.selected.currentValue;
                    this.calculateAppearCount(this.selected);
                    this.calculateContinueCount(this.selected);
                    this.calculateMaxLoseCount(this.selected);
                    this.initMainData(this.selected);
                }
                if (changes.openList) {
                    this.trendQuery = 'latest-30';
                    this.openList = changes.openList.currentValue;
                    const len = this.openList.length - 1;
                    this.openListTemp = [];
                    let position = this.openList[0].expect.indexOf('-');
                    this.openList.forEach((e, k) => {
                        e.expect = position == -1 ? e.expect : e.expect.substr(position + 1, e.expect.length); // 期号
                        if (e.code && typeof e.code == 'string') e.code = e.code.split(',');
                        if (k == len) {
                            this.openListTemp = this.openList.concat();
                            // console.log('this.openList', this.openList,'this.openListTemp=',this.openListTemp);
                            this.openList.reverse();
                            if (!changes.openList.firstChange) {
                                this.initTrend();
                            }
                        }
                    });
                }
                if (changes.param) {
                    this.param = changes.param.currentValue;
                    this.initTrend();
                }
            }
        }
    }

    initTrend() {
        switch (this.param) {
            case 'dingwei':  // 单号走势
                this.trendMode = 'dingwei';
                this.minNum = 0;
                this.maxNum = 9;
                this.initTabs(this.lotteryType);
                this.calculateAppearCount(this.selected);    // 出现次数
                this.calculateContinueCount(this.selected);  // 最大连出
                this.calculateMaxLoseCount(this.selected);   // 最大遗漏
                this.initMainData(this.selected);
                break;
            case '5x':
            case '4q':
            case '4h':
            case '3q':
            case '3z':
            case '3h':
            case '2q':
            case '2h': // 多号走势
                this.trendMode = 'numTrend';
                this.minNum = 0;
                this.maxNum = 9;
                this.numTrendData();
                break;
            case 'zsModel': // 组三形态
                this.trendMode = 'zsModel';
                this.minNum = 1;
                this.maxNum = 6;
                this.openNumberArr = ['前三组三', '前三组六', '中三组三', '中三组六', '后三组三', '后三组六'];
                this.zsTrendData();
                break;
            case '0102':
            case '0304':
            case '1213':
            case '1423':
            case '2434': // 龙虎走势
                this.trendMode = 'longhuModel';
                const titleArr = ['万', '千', '百', '十', '个'];
                this.minNum = 0;
                this.maxNum = 7;
                this.openNumberArr = [
                    titleArr[Number(this.param.substr(0, 1))] + ' vs ' + titleArr[Number(this.param.substr(1, 1))],
                    '龙', '和', '虎',
                    titleArr[Number(this.param.substr(2, 1))] + ' vs ' + titleArr[Number(this.param.substr(3, 1))],
                    '龙', '和', '虎'];
                this.longhuTrendInit();
                break;
        }
    }

    /** 初始化组三数组 */
    initZsModelArr() {
        return [0, 0, 0, 0, 0, 0];
    }
    /** 初始化龙虎数组 */
    initLhModelArr() {
        return ['-', 0, 0, 0, '-', 0, 0, 0];
    }

    /** 初始化tab
     * sing 20190721
     */
    initTabs(type) {
        switch (type) {
            // 十一选五
            case '02':
                this.minNum = 1;
                this.maxNum = 11;
                this.tabs = ['万', '千', '百', '十', '个'];
                break;
            // 快三
            case '07':
                this.minNum = 1;
                this.maxNum = 6;
                this.tabs = ['百', '十', '个'];
                break;
            // 3D 、PC蛋蛋
            case '03':
            case '10':
                this.minNum = 0;
                this.maxNum = 9;
                this.tabs = ['百', '十', '个'];
                break;
            // PK10
            case '08':
                this.minNum = 1;
                this.maxNum = 10;
                this.tabs = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
                break;
            // ccs等
            case '01':
                this.minNum = 0;
                this.maxNum = 9;
                this.tabs = ['万', '千', '百', '十', '个'];
        }
        this.selected = this.tabs[0];
    }


    /** 初始化备用数组 */
    initStatisticArr(obj) {
        switch (obj) {
            case 'appearCount':
                this.appearCount = [];
                break;
            case 'maxContinueCount':
                this.maxContinueCount = [];
                break;
            case 'maxLoseCount':
                this.maxLoseCount = [];
                break;
            case 'MainData':
                this.MainDataTemp = [];
                break;
            case 'averageLoseCount':
                this.averageLoseCount = [];
                break;
            case 'numTrendData':
                this.numTrendMianData = [];
                break;
        }
        if (this.param != 'zsModel') this.openNumberArr = [];
        for (let i = 0, len = this.maxNum - this.minNum, j = this.minNum; i <= len; i++ , j++) {
            if (this.param != 'zsModel') {
                if ((this.lotteryType == '02' || this.lotteryType == '08') && j.toString().length == 1) {
                    this.openNumberArr.push('0' + j);
                } else {
                    this.openNumberArr.push(j);
                }
            }
            switch (obj) {
                case 'appearCount':
                    this.appearCount.push(0);
                    break;
                case 'maxContinueCount':
                    this.maxContinueCount.push(0);
                    break;
                case 'maxLoseCount':
                    this.maxLoseCount.push(0);
                    break;
                case 'MainData':
                    this.MainDataTemp.push(0);
                    break;
                case 'averageLoseCount':
                    this.averageLoseCount.push(0);
                    break;
                case 'numTrendData':
                    this.numTrendMianData.push({ num: null, count: 1 });
                    break;
            }
        }
    }

    setMarkHeight() {
        /* this.timer = setInterval(() => {
            if ($('#trend-header')) {
                let h = $('#trend-header').height() + $('#lottery-main-header').height();
                clearInterval(this.timer);
                setTimeout(() => {
                    $('.brick-trend-content').attr('style', 'top:' + h + 'px');
                }, 300);
            }
        }, 50) */
    }
    filterTitle: string;
    /** 走势筛选模式 */
    openFilter() {
        let param = [];
        param['param'] = this.param;
        param['LotteryType'] = this.lotteryType;
        let modal = this.popCtrl.create(BrickTrendScreen, param, { cssClass: "screen_filter" });
        modal.present();
        modal.onWillDismiss((data: any) => {
            if (data) {
                this.param = data.param;
                switch (this.param) {
                    case 'dingwei':
                        this.trendMode = 'dingwei';
                        this.openNumberArr = [];
                        for (let i = 0, len = this.maxNum - this.minNum, j = this.minNum; i <= len; i++ , j++) {
                            if ((this.lotteryType == 2 || this.lotteryType == '08') && j.toString().length == 1) {
                                this.openNumberArr.push('0' + j);
                            } else {
                                this.openNumberArr.push(j);
                            }
                        }
                        this.initTrend();
                        break;
                    case 'zsModel':
                        this.trendMode = 'zsModel';
                        this.filterTitle = '组三形态';
                        this.openNumberArr = ['前三组三', '前三组六', '中三组三', '中三组六', '后三组三', '后三组六'];
                        this.initTrend();
                        break;
                    case '5x':
                    case '4q':
                    case '4h':
                    case '3q':
                    case '3z':
                    case '3h':
                    case '2q':
                    case '2h':
                        this.trendMode = 'numTrend';
                        this.minNum = 0;
                        this.maxNum = 9;
                        this.openNumberArr = [];
                        for (let i = 0, len = this.maxNum - this.minNum, j = this.minNum; i <= len; i++ , j++) {
                            this.openNumberArr.push(j);
                        }
                        this.filterParamObj.forEach(e => {
                            for (const key in e.mode) {
                                if (e.mode.hasOwnProperty(key) && this.param == key) {
                                    this.filterTitle = e.title + '_' + e.mode[key];
                                    return;
                                }
                            }
                        });
                        this.initTrend();
                        break;
                    case '0102':
                    case '0304':
                    case '1213':
                    case '1423':
                    case '2434':
                        this.trendMode = 'longhuModel';
                        const titleArr = ['万', '千', '百', '十', '个'];
                        this.openNumberArr = [
                            titleArr[Number(this.param.substr(0, 1))] + ' vs ' + titleArr[Number(this.param.substr(1, 1))],
                            '龙', '和', '虎',
                            titleArr[Number(this.param.substr(2, 1))] + ' vs ' + titleArr[Number(this.param.substr(3, 1))],
                            '龙', '和', '虎'];
                        this.filterParamObj.forEach(e => {
                            for (const key in e.mode) {
                                if (e.mode.hasOwnProperty(key) && this.param == key) {
                                    this.filterTitle = e.title + '_' + e.mode[key];
                                    return;
                                }
                            }
                        });
                        this.initTrend();
                        break;
                }

            }
        });
    }
    /** 切换定位 */
    changePosition(obj) {
        this.selected = obj;
        this.calculateAppearCount(this.selected);
        this.calculateContinueCount(this.selected);
        this.calculateMaxLoseCount(this.selected);
        this.initMainData(this.selected);
    }
    trendQuery = 'latest-30';
    /** 切换期数 */
    selectRange(range: string) {
        this.trendQuery = range;
        if(!this.numberTrend) {
            clearCanvas()
            this.queryTrend();            
        } else {
            this.queryTrend();
        }
    }

    /**
     * 走势图数据
     * sing 20190727
     */
    queryTrend() {
        let param: TrendInputModel = {
            lotteryId: this.brick.LotteryCode,
            command: this.trendQuery,
        }
        return this.lotteryService.trendData(param).then(s => {
            if (s && s.list && s.list.length) {
                // console.log(s);
                this.openList = s.list;

                const len = this.openList.length - 1;
                this.openListTemp = [];
                let position = this.openList[0].expect.indexOf('-');
                this.openList.forEach((e, k) => {
                    e.expect = position == -1 ? e.expect.length > 5 ? e.expect.substr(e.expect.length - 5, e.expect.length) : e.expect :
                        e.expect.substr(position + 1, e.expect.length); // 期号
                    if (e.code && typeof e.code == 'string') e.code = e.code.split(',');
                    if (k == len) {
                        this.openListTemp = this.openList.concat();
                        // console.log('this.openList', this.openList,'this.openListTemp=',this.openListTemp);
                        this.openList.reverse();
                        this.initTrend();

                    }
                });
                // this.initTrend();
            } else {
                return this.alert.showAlert('今日还未开奖');
            }
        }).catch(e => {
            // this.alert.showAlert(e.message);
        })
    }

    /**
     * 计算单号走势出现次数
     *
    */
    calculateAppearCount(position) {
        this.initStatisticArr('appearCount');   // 初始化数组
        let idx = this.tabs.findIndex(v => { return v == position; });
        this.openList.forEach((e, k) => {
            let index = Number(e.code[idx]);
            index = !this.minNum ? index : index - 1; // 如果最小开奖号码是1，则 index 需 -1
            this.appearCount[index]++;
        });
    }

    /**
     *  计算单号走势最大连出
     *
    */
    calculateContinueCount(position) {
        this.initStatisticArr('maxContinueCount');   // 初始化数组
        let idx = this.tabs.findIndex(v => { return v == position; });
        this.openList.forEach((e, k) => {
            let num = Number(e.code[idx]); // 当前位置开奖号码  个/十/百/千/万
            let index = !this.minNum ? num : num - 1; // 如果最小开奖号码是1，则 index 需 -1
            if (k == 0 || this.maxContinueCount[index] == 0) {
                this.maxContinueCount[index]++;
            }
            else {
                let isCanPlus = true;
                for (let i = k, count = k - this.maxContinueCount[index]; i >= count; i--) {
                    // 当且仅当连续出现次数比上次的大才允许++
                    if (num != Number(this.openList[i].code[idx])) isCanPlus = false;
                    if (isCanPlus && i == count) {
                        this.maxContinueCount[index]++;
                    }
                }
            }
        })
    }

    /**
     * 计算单号走势最大遗漏
     *
    */
    calculateMaxLoseCount(position) {
        this.initStatisticArr('maxLoseCount');   // 初始化数组
        let idx = this.tabs.findIndex(v => { return v == position; });
        for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
            // 创建一个空数组，每次遗漏次数push到数组，最后取最大值
            let tempArr = [], len = this.openList.length - 1;
            this.openList.forEach((e, k) => {
                let num = Number(e.code[idx]);
                // let index = !this.minNum ? num : num - 1; // 如果最小开奖号码是1，则 index 需 -1
                if (num != i) {
                    this.maxLoseCount[j]++;
                } else {
                    tempArr.push(this.maxLoseCount[j]);
                    this.maxLoseCount[j] = 0;
                }
                if (k == len) {
                    tempArr.push(this.maxLoseCount[j]);
                    // 从数组中取最大值
                    this.maxLoseCount[j] = Math.max.apply(null, tempArr);
                    // console.log('tempArr', tempArr);
                    if (i == this.maxNum) {
                        // console.log('this.maxLoseCount=', this.maxLoseCount);
                        // 计算平均遗漏
                        this.calculateAverageLoseCount();
                    }
                }
            })
        }
    }

    /**
     * 计算平均遗漏
     *
    */
    calculateAverageLoseCount() {
        this.initStatisticArr('averageLoseCount');   // 初始化数组
        const len = this.openList.length;
        this.statisticArr = [];
        this.averageLoseCount.forEach((e, k) => {
            const num = Number(this.appearCount[k]) >= 1 ? this.appearCount[k] : 1;
            const total = len - this.appearCount[k] >= 1 ? len - this.appearCount[k] : 1;
            this.averageLoseCount[k] = Math.ceil(total / num);
            // this.averageLoseCount[k] = Math.ceil(len / (len - this.appearCount[k]));
            if (k == this.averageLoseCount.length - 1) {
                // console.log('this.averageLoseCount=', this.averageLoseCount);
                this.statisticArr.push(this.appearCount);
                this.statisticArr.push(this.maxContinueCount);
                this.statisticArr.push(this.maxLoseCount);
                this.statisticArr.push(this.averageLoseCount);
            }
        });
    }

    /** 定位走势主体 */
    initMainData(position) {
        this.initStatisticArr('MainData');   // 初始化数组
        this.numMainList = [];
        let idx = this.tabs.findIndex(v => { return v == position; });
        let len = this.openList.length - 1;
        let listTemp = [];
        listTemp = this.openList.slice();
        if (listTemp.length > 1 && Number(this.openList[0].expect) > Number(this.openList[1].expect)) {
            listTemp.reverse();
        }
        listTemp.forEach((e, k) => {
            let mainObj = new TrendModel();
            // let position = e.expect.indexOf('-');
            // mainObj.expect = position == -1 ? e.expect : e.expect.substr(position + 1, e.expect.length); // 期号
            mainObj.expect = e.expect;
            this.numMainList.push(mainObj);
            let num = e.code[idx], numTemp = Number(e.code[idx]);
            let index = !this.minNum ? numTemp : numTemp - 1; // 如果最小开奖号码是1，则 index 需 -1
            for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                if (j != index) {
                    /* 如果上一个是开奖号码 而这次不是了遗漏次数为 1 */
                    if (typeof this.MainDataTemp[j] == 'string') {
                        this.MainDataTemp[j] = 1;
                    } else {
                        /* 上一个不是开奖号码 这次也不是遗漏值 +1 */
                        this.MainDataTemp[j]++;
                    }
                } else {  /* 开奖号码 直接把号码字符串填入数组 */
                    this.MainDataTemp[j] = num;
                }
                if (i == this.maxNum) {
                    const temp = this.MainDataTemp;
                    this.numMainList[k].list = [];
                    this.numMainList[k].list = this.numMainList[k].list.concat(temp);
                }
                if (i == this.maxNum && k == len && k > 0) {
                    if (Number(this.numMainList[0].expect) < Number(this.numMainList[1].expect) ||
                        Number(this.numMainList[1].expect) < Number(this.numMainList[2].expect)) {
                        this.numMainList.reverse();
                        this.getPosition();
                        // setTimeout(() => {
                        // }, 500);
                    } else {
                        this.getPosition();
                        // setTimeout(() => {
                        // }, 500);
                    }
                }
            }
        })
    }

    /** 取坐标画线 */
    getPosition() {
        /** 坐标数组 */
        let positionArr = [];
        let timer = setInterval(() => {
            /** 直到dom渲染完成拿到dom数组 终止循环 */
            let container = document.querySelector('brick-trend-page .main-trend') as HTMLElement;
            let paths = document.querySelectorAll('brick-trend-page .main-trend .bingo');
            if (container && paths.length) {
                clearInterval(timer);
                let containerRect = container.getBoundingClientRect();
                for (let i = 0, len = paths.length; i < len; i++) {
                    let pathRect = (paths[i] as HTMLElement).getBoundingClientRect();
                    positionArr.push([
                        pathRect.left - containerRect.left + container.scrollLeft + pathRect.width / 2,
                        pathRect.top - containerRect.top + container.scrollTop + pathRect.height / 2
                    ]);
                    if (i == len - 1) {
                        DrawTrend(container.clientWidth, positionArr, 0);
                    }
                }
            }
        }, 50);
    }

    /** 号码走势主体 */
    numTrendData() {
        this.initStatisticArr('numTrendData');   // 初始化数组
        let len = this.openList.length - 1;
        let listTemp = [];
        listTemp = this.openList.slice();
        if (Number(this.openList[0].expect) > Number(this.openList[1].expect)) {
            listTemp.reverse();
        }
        setTimeout(() => {
            this.numMainList = [];
            listTemp.forEach((e, k) => {
                let numList = this.numTrend(this.param, e.code);
                // console.log(e.code)
                const leng = numList.length - 1;
                numList.forEach((v, l) => {
                    let num = v, numTemp = Number(v);
                    let index = !this.minNum ? numTemp : numTemp - 1; // 如果最小开奖号码是1，则 index 需 -1
                    for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                        // console.log('this.numTrendMianData[j]', this.numTrendMianData[j], this.numTrendMianData)
                        if (j != index) {
                            /* 如果上一个是开奖号码 而这次不是了遗漏次数为 1 */
                            if (typeof this.numTrendMianData[j].num == 'string' && l == 0) {
                                this.numTrendMianData[j].num = 1;
                            } else if (l == 0) {
                                /* 上一个不是开奖号码 这次也不是遗漏值 +1 */
                                this.numTrendMianData[j].num++;
                            }
                        } else {  /* 开奖号码 直接把号码字符串填入数组 */
                            if (this.numTrendMianData[j].num === num) {
                                this.numTrendMianData[j].count++;
                            } else {
                                this.numTrendMianData[j].num = num;
                            }
                        }
                        if (l == 0) {
                            this.numTrendMianData[j].count = 1;
                        }
                        if (i == this.maxNum && l == leng) {
                            let mainObj = new TrendModel();
                            mainObj.expect = e.expect;
                            mainObj.list = JSON.parse(JSON.stringify(this.numTrendMianData));
                            this.numMainList.push(mainObj);
                            // console.log(mainObj.expect, 'this.MainDataTemp=', mainObj.list);
                        }
                        if (i == this.maxNum && k == len && l == leng) {
                            // console.log('this.numMainList==+++++++', this.numMainList);
                            if (Number(this.numMainList[0].expect) < Number(this.numMainList[1].expect) ||
                                Number(this.numMainList[1].expect) < Number(this.numMainList[2].expect)) {
                                this.numMainList.reverse();
                                this.numTrendStatistic(this.numMainList);
                            } else {
                                this.numTrendStatistic(this.numMainList);
                            }
                        }
                    }
                });
            })
        }, 0);
    }

    /**
     * sing 20190802
     * @param arr 传入数组数据
     */
    numTrendStatistic(arr: any[]) {
        this.initStatisticArr('appearCount');
        this.initStatisticArr('maxContinueCount');
        this.initStatisticArr('maxLoseCount');
        this.initStatisticArr('averageLoseCount');
        this.initStatisticArr('numTrendData');   // 初始化数组
        const len = arr.length - 1;
        arr.forEach((e, k) => {
            for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                if (typeof e.list[j].num == 'string') {
                    // 出现次数
                    this.appearCount[j]++;
                    // 最大连出
                    let isCanPlus = 0;
                    for (let m = k; arr[m] && typeof arr[m].list[j].num == 'string' && m <= len; m++) {
                        // 当且仅当连续出现次数比上次的大才允许++
                        if (typeof arr[m].list[j].num == 'string') {
                            isCanPlus++;
                        }
                        // 当且仅当连续出现次数比上次的大才允许赋值
                        if (isCanPlus > this.maxContinueCount[j]) {
                            this.maxContinueCount[j] = isCanPlus;
                        }
                    }
                } else {
                    // 最大遗漏
                    this.maxLoseCount[j] = e.list[j].num > this.maxLoseCount[j] ? e.list[j].num : this.maxLoseCount[j];
                }
                if (k == len && i == this.maxNum) {
                    this.calculateAverageLoseCount();
                }
            }
        });
    }

    /** 返回多号走势号码数组 */
    numTrend(param: string, list: any[]) {
        let lang = parseInt(param);
        const codeLen = this.openListTemp[0].code.length;
        const tempArr = list.slice();
        if (param.indexOf('x') >= 0) {
            let numList = tempArr.splice(0, 5);
            return numList;
        } else if (param.indexOf('q') >= 0) {
            let numList = tempArr.splice(0, lang);
            return numList;
        } else if (param.indexOf('z') >= 0) {
            let numList = tempArr.splice(1, 3);
            return numList;
        } else if (param.indexOf('h') >= 0) {
            let numList = tempArr.splice(codeLen - lang, codeLen);
            return numList;
        }
    }

    /**    组三-------------------------------------------------------------------------------------------------------------------- */
    /**    组三-------------------------------------------------------------------------------------------------------------------- */
    /**    组三-------------------------------------------------------------------------------------------------------------------- */
    /**    组三-------------------------------------------------------------------------------------------------------------------- */

    /**
     * 组三形态走势
     */
    zsTrendData() {
        this.appearCount = this.initZsModelArr();
        this.maxContinueCount = this.initZsModelArr();
        this.maxLoseCount = this.initZsModelArr();
        this.averageLoseCount = this.initZsModelArr();
        this.MainDataTemp = this.initZsModelArr();
        let len = this.openList.length - 1;
        let listTemp = [];
        listTemp = this.openList.slice();
        if (Number(this.openList[0].expect) > Number(this.openList[1].expect) || Number(this.openList[1].expect) > Number(this.openList[2].expect)) {
            listTemp.reverse();
        }
        setTimeout(() => {
            this.numMainList = [];
            listTemp.forEach((e, k) => {
                let q3List = this.numTrend('3q', e.code);
                let z3List = this.numTrend('3z', e.code);
                let h3List = this.numTrend('3h', e.code);
                for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                    switch (j) {
                        case 0:
                            this.MainDataTemp[j] = this.checkZsMode(q3List) == 1 ? '三' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 1:
                            this.MainDataTemp[j] = this.checkZsMode(q3List) == 2 ? '六' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 2:
                            this.MainDataTemp[j] = this.checkZsMode(z3List) == 1 ? '三' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 3:
                            this.MainDataTemp[j] = this.checkZsMode(z3List) == 2 ? '六' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 4:
                            this.MainDataTemp[j] = this.checkZsMode(h3List) == 1 ? '三' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 5:
                            this.MainDataTemp[j] = this.checkZsMode(h3List) == 2 ? '六' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            let mainObj = new TrendModel();
                            mainObj.expect = e.expect;
                            mainObj.code = e.code;
                            mainObj.list = JSON.parse(JSON.stringify(this.MainDataTemp));
                            this.numMainList.push(mainObj);
                            break;
                    }
                    if (i == this.maxNum && k == len) {
                        // console.log('this.numMainList==+++++++', this.numMainList);
                        if (Number(this.numMainList[0].expect) < Number(this.numMainList[1].expect) ||
                            Number(this.numMainList[1].expect) < Number(this.numMainList[2].expect)) {
                            this.numMainList.reverse();
                            this.zsModelTrendStatistic(this.numMainList);
                        } else {
                            this.zsModelTrendStatistic(this.numMainList);
                        }
                    }
                }
            })
        }, 0);
    }

    /** 判断组三形态 */
    checkZsMode(arr: any[]) {
        if (arr[0] == arr[1] && arr[0] == arr[2]) {
            // 豹子号
            return 3;
        } else if (arr[0] != arr[1] && arr[0] != arr[2] && arr[1] != arr[2]) {
            // 组六
            return 2;
        } else if ((arr[0] == arr[1] && arr[0] != arr[2]) || (arr[0] != arr[1] && arr[1] == arr[2]) || (arr[0] == arr[2] && arr[1] != arr[2])) {
            // 组三
            return 1;
        }
    }

    /** 组三形态统计 */
    zsModelTrendStatistic(arr: any[]) {
        this.initStatisticArr('appearCount');
        this.initStatisticArr('maxContinueCount');
        this.initStatisticArr('maxLoseCount');
        this.initStatisticArr('averageLoseCount');
        this.initStatisticArr('numTrendData');   // 初始化数组
        const len = arr.length - 1;
        arr.forEach((e, k) => {
            for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                if (typeof e.list[j] == 'string') {
                    // 出现次数
                    this.appearCount[j]++;
                    // 最大连出
                    let isCanPlus = 0;
                    for (let m = k; arr[m] && typeof arr[m].list[j] == 'string' && m <= len; m++) {
                        // 当且仅当连续出现次数比上次的大才允许++
                        if (typeof arr[m].list[j] == 'string') {
                            isCanPlus++;
                        }
                        // 当且仅当连续出现次数比上次的大才允许赋值
                        if (isCanPlus > this.maxContinueCount[j]) {
                            this.maxContinueCount[j] = isCanPlus;
                        }
                    }
                } else {
                    // 最大遗漏
                    this.maxLoseCount[j] = e.list[j] > this.maxLoseCount[j] ? e.list[j] : this.maxLoseCount[j];
                }
                if (k == len && i == this.maxNum) {
                    // console.log('出现次数 this.appearCount===', this.appearCount);
                    // console.log('最大遗漏 this.maxLoseCount===', this.maxLoseCount);
                    // console.log('最大连出 this.maxContinueCount===', this.maxContinueCount);
                    this.calculateAverageLoseCount();
                }
            }
        });
    }

    /***  龙虎-------------------------------------------------------------------------------- */
    /***  龙虎-------------------------------------------------------------------------------- */
    /***  龙虎-------------------------------------------------------------------------------- */

    /** 获取龙虎判定数组 */
    getLongHuArr(arr: any[], param: string) {
        let firstArr = [], secondArr = [];
        firstArr.push(arr[Number(param.substr(0, 1))]);
        firstArr.push(arr[Number(param.substr(1, 1))]);
        secondArr.push(arr[Number(param.substr(2, 1))]);
        secondArr.push(arr[Number(param.substr(3, 1))]);
        return [firstArr, secondArr];
    }

    /** 判断龙虎形态 */
    checkLongHu(arr: any[]) {
        if (!arr.length) {
            return;
        }
        let long = Number(arr[0]), hu = Number(arr[1]);
        if (long > hu) {
            return '龙';
        } else if (hu > long) {
            return '虎';
        } else if (long == hu) {
            return '和';
        } else {
            return '-';
        }
    }

    /** 龙虎走势主体 */
    longhuTrendInit() {
        this.MainDataTemp = this.initLhModelArr();
        let len = this.openList.length - 1;
        let listTemp = [];
        listTemp = this.openList.slice();
        if (Number(this.openList[0].expect) > Number(this.openList[1].expect) || Number(this.openList[1].expect) > Number(this.openList[2].expect)) {
            listTemp.reverse();
        }
        setTimeout(() => {
            this.numMainList = [];
            listTemp.forEach((e, k) => {
                const operateArr = this.getLongHuArr(e.code, this.param);
                // console.log(e.code, operateArr);
                for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                    switch (j) {
                        case 0:
                            this.MainDataTemp[j] = operateArr[0][0] + ' vs ' + operateArr[0][1];
                            break;
                        case 1:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[0]) === '龙' ? '龙' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 2:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[0]) === '和' ? '和' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 3:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[0]) === '虎' ? '虎' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 4:
                            this.MainDataTemp[j] = operateArr[1][0] + ' vs ' + operateArr[1][1];
                            break;
                        case 5:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[1]) === '龙' ? '龙' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 6:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[1]) === '和' ? '和' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            break;
                        case 7:
                            this.MainDataTemp[j] = this.checkLongHu(operateArr[1]) === '虎' ? '虎' : typeof this.MainDataTemp[j] == 'string' ? 1 : this.MainDataTemp[j] + 1;
                            let mainObj = new TrendModel();
                            mainObj.expect = e.expect;
                            mainObj.code = e.code;
                            mainObj.list = JSON.parse(JSON.stringify(this.MainDataTemp));
                            this.numMainList.push(mainObj);
                            break;
                    }
                    if (i == this.maxNum && k == len) {
                        if (Number(this.numMainList[0].expect) < Number(this.numMainList[1].expect) ||
                            Number(this.numMainList[1].expect) < Number(this.numMainList[2].expect)) {
                            this.numMainList.reverse();
                            this.lhModelTrendStatistic(this.numMainList);
                        } else {
                            this.lhModelTrendStatistic(this.numMainList);
                        }
                        // console.log('this.numMainList==+++++++', this.numMainList);
                    }
                }
            });
        }, 0);
    }

    /** 龙虎形态统计 */
    lhModelTrendStatistic(arr: any[]) {
        this.appearCount = this.initLhModelArr();
        this.maxContinueCount = this.initLhModelArr();
        this.maxLoseCount = this.initLhModelArr();
        this.averageLoseCount = this.initLhModelArr();
        const len = arr.length - 1;
        arr.forEach((e, k) => {
            for (let i = this.minNum, j = 0; i <= this.maxNum; i++ , j++) {
                if (j != 0 && j != 4) {
                    if (typeof e.list[j] == 'string') {
                        // 出现次数
                        this.appearCount[j]++;
                        // 最大连出
                        let isCanPlus = 0;
                        for (let m = k; arr[m] && typeof arr[m].list[j] == 'string' && m <= len; m++) {
                            // 当且仅当连续出现次数比上次的大才允许++
                            if (typeof arr[m].list[j] == 'string') {
                                isCanPlus++;
                            }
                            // 当且仅当连续出现次数比上次的大才允许赋值
                            if (isCanPlus > this.maxContinueCount[j]) {
                                this.maxContinueCount[j] = isCanPlus;
                            }
                        }
                    } else {
                        // 最大遗漏
                        this.maxLoseCount[j] = e.list[j] > this.maxLoseCount[j] ? e.list[j] : this.maxLoseCount[j];
                    }
                    if (k == len && i == this.maxNum) {
                        this.calculateLongHuAverageLoseCount();
                    }
                }
            }
        });
    }

    /**
     * 计算平均遗漏
     *
    */
    calculateLongHuAverageLoseCount() {
        const len = this.openList.length;
        this.statisticArr = [];
        this.averageLoseCount.forEach((e, k) => {
            if (k != 0 && k != 4) {
                const num = Number(this.appearCount[k]) >= 1 ? this.appearCount[k] : 1;
                const total = len - this.appearCount[k] >= 1 ? len - this.appearCount[k] : 1;
                this.averageLoseCount[k] = Math.ceil(total / num);
                if (k == this.averageLoseCount.length - 1) {
                    this.statisticArr.push(this.appearCount);
                    this.statisticArr.push(this.maxContinueCount);
                    this.statisticArr.push(this.maxLoseCount);
                    this.statisticArr.push(this.averageLoseCount);
                }
            }
        });
    }

}


export class TrendModel {
    constructor() {
        this.expect = null;
        this.code = null;
        this.list = [];
    }
    expect: string;
    list: any[];
    code: string;
}

export class TrendInputModel {
    constructor() {
        this.lotteryId = '';
        this.command = ''
    }
    lotteryId: string;
    command: string
}



// WEBPACK FOOTER //
// ./src/pages/lotteryopen/brick-trend/brick-trend.ts